/*
 * Project: LegalPlace assistant
 * File: src\components\wizard_body.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */


import React, { Component } from 'react';
import { connect } from 'react-redux';
import lpApp from '../app/lp_app';

class _WizardBody extends Component {
  // WOW
  // shouldComponentUpdate(newProps, newState){
  //     if(newProps.currentSection != this.props.currentSection)
  //         return true;
  //     else
  //         return false;
  // }

  componentDidMount() {
    const wizardObserver = new MutationObserver((m) => {
      function getElHeight(el) {
        if (el) {
          const positionInfo = el.offsetHeight;
          return positionInfo;
        }
        return '0';
      }
      const wizard = document.querySelector('.wizard');


      const asideList = document.querySelector('.forcing-summary ul');
      if (asideList) {
        asideList.style.height = `${wizard ? getElHeight(wizard) : '0'}px`;
      }
    });
    wizardObserver.observe(document.querySelector('.wizard-content'), { childList: true, subtree: true });
  }

  componentWillUpdate() {
    // console.log("%cstart section", "color: red");
    // window.section_transition = true;
  }

  componentDidUpdate() {
    if (!this.props.mazel && (this.props.doc_state === 'continue' || window.autosave)) {
      if ((typeof window.lp[this.props.currentSection] !== 'undefined') && !window.lp[this.props.currentSection] && ((lpApp.continuity && (lpApp.continuity.continue != '')) || window.autosave)) {
        // console.time("initialization");
        // _initializeOptions1(this.props.options, false);
        lpApp.ops.initialization.intiialize(this.props.options, false);
        // console.timeEnd("initialization");
        // this.props._initOne(this.props.currentSection-1);

        window.lp[this.props.currentSection] = true;
        // console.log("inited")
      }
    }
    // console.log("%cfinish section", "color: red")
    // window.section_transition = false;
    lpApp.mutex.setMutex('preview', true);
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      //Isolate the node that we're after
      const currentNode = event.target;

      // If current focused element is a textarea we should ignore the enter event
      if(currentNode.type === "textarea") return;

      event.preventDefault();

      let wizard_content = document.querySelector('.wizard-content');

      //find all tab-able elements
      const allElements = wizard_content.querySelectorAll('.input-field .form-group input, .input-field .form-group select, .input-field .form-group textarea');

      //Find the current tab index.
      const currentIndex = [...allElements].findIndex(el => currentNode.isEqualNode(el))

      //focus the following element or click next if last
      if (currentIndex + 1 < allElements.length) {
        allElements[currentIndex + 1].focus();
      } else {
        // should click next btn
      }
    }
  }

  render() {
    return (
      <form className={`wizard-content${lpApp.isPayed && !lpApp.ops.two_steps.isDiscovered(this.props.currentSection, 'section') ? ' highlight-second' : ''}`} onKeyPress={this.handleKeyPress}>
        {this.props.mandatory_error && <div className="form-output">Veuillez remplir tous les champs obligatoires</div>}
        { this.props.children }
      </form>
    );
  }
}


const mapStateToProps = (state) => {
  if (state.loading_details.wizard) {
    return {
      mazel: true,
    };
  }
  return {
    mazel: false,
    currentSection: state.contract.currentSection,
    doc_state: state.document_state.state,
    options: state.contract.section.option_ids,
    mail: state.account_settings.mail,
    mandatory_error: state.errors.components.mandatory,
  };
};

const WizardBody = connect(mapStateToProps)(_WizardBody);

export default WizardBody;



// WEBPACK FOOTER //
// ./src/components/wizard_body.js